import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon } from '../../atoms';

const StyledButton = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  color: var(--content-subtitle);

  cursor: pointer;

  transition: background 0.2s, color 0.2s;

  &:hover {
    background: var(--wash-gray-hover);
    color: var(--content-body);
  }

  &:active {
    background: var(--wash-gray-pressed);
    color: var(--content-body);
  }
`;

const SidebarAddButton = ({ className = null, onClick }) => (
  <StyledButton className={className} onClick={onClick}>
    <Icon size={20} name='plus' />
  </StyledButton>
);

SidebarAddButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export { SidebarAddButton };
